import { useSession } from "@/lib/auth-react";
import { useState } from "react";
import { stopBackendImpersonation } from "@/utils/impersonate";

export function useLogout() {
  const { data: session } = useSession();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const isImpersonating = !!session?.impersonatedBy;

  /**
   * @param impersonationRedirect — where to land after ending impersonation.
   *   Defaults to `/dashboard`, but the impersonation pill passes
   *   `/dashboard/users` so admins return to the user table they started from.
   */
  const handleLogout = async (impersonationRedirect = "/dashboard") => {
    try {
      setIsLoggingOut(true);
      if (isImpersonating) {
        // Admin token lives in the HttpOnly `rawiah.admin_session` cookie.
        // /api/admin/impersonate/stop restores it as the session cookie
        // and we hard-reload to the chosen destination. The impersonated
        // user's name rides along so the destination page can toast it.
        await stopBackendImpersonation(
          impersonationRedirect,
          session?.user?.name ?? null,
        );
        return;
      }

      // Plain sign-out: clear the backend session cookie + bounce home.
      await fetch("/api/auth/logout", {
        method: "POST",
        credentials: "include",
      }).catch(() => undefined);
      window.location.assign("/");
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return {
    handleLogout,
    isLoggingOut,
    isImpersonating,
  };
}
